import React from 'react';
import CommonLogin from '@common/pages/login/login';

const Login: React.FC = () => <CommonLogin mode="web" callback={() => undefined} />;

export default Login;
